import { ColorsEnum } from "../et3-theme/colors";
import {
  SURFACE_BORDER,
  SURFACE_HAIRLINE_COLOR,
  SURFACE_HEADER_BACKGROUND,
  SURFACE_RADIUS_CSS,
  SURFACE_SHADOW
} from "../et3-theme/surface-constants";

const ALPHA_HOVER = "0A";
const ALPHA_DASH = "33";

export const TABLE_RADIUS_CSS = SURFACE_RADIUS_CSS;
export const TABLE_EMPTY_BODY_HEIGHT = 120;
export const TABLE_EMPTY_ICON_SIZE = 26;
export const TABLE_EMPTY_GAP = 10;
export const TABLE_EMPTY_FONT_SIZE = 15;
export const TABLE_HEADER_FONT_WEIGHT = 600;
export const TABLE_HEADER_MAX_HEIGHT_CSS = "200px";
export const TABLE_HEADER_LINE_HEIGHT_CSS = "20px";

export const TABLE_BORDER = SURFACE_BORDER;
export const TABLE_SHADOW = SURFACE_SHADOW;
export const TABLE_EMPTY_BORDER = `1px dashed ${ColorsEnum.maastrichtBlue}${ALPHA_DASH}`;
export const TABLE_HEADER_BACKGROUND = SURFACE_HEADER_BACKGROUND;
export const TABLE_ROW_HOVER_BACKGROUND = `${ColorsEnum.bondiBlue}${ALPHA_HOVER}`;
export const TABLE_CELL_BORDER_COLOR = SURFACE_HAIRLINE_COLOR;
